import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Divider, Tooltip } from '@material-ui/core';
import classNames from 'classnames';
import { ToCurrencyString, ToPercentageString } from './../../../services/formatService';

const PropertyProforma = ({ classes, propertyDetailsData }) => {
    const canDisplay = (number) => {
        if (number == null || isNaN(number) || number === 0) {
            return false;
        }
        return true;
    }

    const GetCurrencyString = (number, isNegative = false, fontBold = false) => {
        return (<Typography className={classNames(classes.valueSpacing, classes.tabContent, (isNegative ? classes.fontRed : null), (fontBold ? classes.fontBold : null))} variant='body2'>
            {canDisplay(number) ? (isNegative ? `(${ToCurrencyString(Math.abs(number))})` : `${ToCurrencyString(number)}`) : '-'}
        </Typography>)
    }

    return (
        <div style={{ width: '250px' }}>
            <Fragment>
                <Typography variant='subtitle2' align='left'>{'INCOME'}</Typography>
                <div className={classes.groupContainer}>
                    {/* Gross Potential Rent */}
                    <div className={classes.proformaSpacing}>
                        <Tooltip title={'Gross Potential Rent'}>
                            <Typography variant='body2' className={classes.tabContent}>{'GPR'}</Typography>
                        </Tooltip>
                        <Typography className={classes.tabSubContent} variant='body2'>
                            {propertyDetailsData.gpr ? `${ToCurrencyString(propertyDetailsData.gpr / 12)}/mo` : null}
                        </Typography>
                        {GetCurrencyString(propertyDetailsData.gpr)}
                    </div>

                    {/* Vacancy Loss */}
                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classes.tabContent}>{'Vacancy Loss'}</Typography>
                        {/* <Typography className={classes.tabSubContent} variant='body2'>
                            {propertyDetailsData.vacancyLoss ? ToPercentageString(propertyDetailsData.vacancyLoss) : null}
                        </Typography> */}
                        {GetCurrencyString(propertyDetailsData.vacancyLoss, true)}
                    </div>

                    {/* Credit Loss */}
                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classes.tabContent}>{'Credit Loss'}</Typography>
                        {/* <Typography className={classes.tabSubContent} variant='body2'>
                            {propertyDetailsData.creditLoss ? ToPercentageString(propertyDetailsData.creditLoss) : null}
                        </Typography> */}
                        {GetCurrencyString(propertyDetailsData.creditLoss, true)}
                    </div>

                    <Divider variant='middle' />

                    <div className={classes.proformaSpacing}>
                        <Tooltip title={'Effective Gross Income'}>
                            <Typography variant='body2' className={classNames(classes.fontBold, classes.tabContent)}>
                                {'EGI'}
                            </Typography>
                        </Tooltip>
                        {GetCurrencyString(propertyDetailsData.egi, false, true)}
                    </div>
                </div>

                <div className={classes.groupContainer} style={{ 'marginTop': '5px' }}>
                    {/* Other Income */}
                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classes.tabContent}>{'Other Income'}</Typography>
                        {/* <Typography className={classes.tabSubContent} variant='body2'>
                            {propertyDetailsData.otherIncome ? ToPercentageString(propertyDetailsData.otherIncome) : null}
                        </Typography> */}
                        {GetCurrencyString(propertyDetailsData.otherIncome)}
                    </div>

                    {/* Concessions */}
                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classes.tabContent}>{'Concessions'}</Typography>
                        {/* <Typography className={classes.tabSubContent} variant='body2'>
                            {propertyDetailsData.concessions ? ToPercentageString(propertyDetailsData.concessions) : null}
                        </Typography> */}
                        {GetCurrencyString(propertyDetailsData.concessions, true)}
                    </div>

                    <Divider variant='middle' />

                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classNames(classes.fontBold, classes.tabContent)}>
                            {'Operating Income'}
                        </Typography>
                        {GetCurrencyString(propertyDetailsData.operatingIncome, false, true)}
                    </div>
                </div>

                <div className={classes.groupContainer} style={{ 'marginTop': '5px' }}>
                    {/* Property Taxes */}
                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classes.tabContent}>{'Property Taxes'}</Typography>
                        {GetCurrencyString(propertyDetailsData.taxes, true)}
                    </div>

                    {/* Insurance */}
                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classes.tabContent}>{'Insurance'}</Typography>
                        {GetCurrencyString(propertyDetailsData.insurance, true)}
                    </div>

                    {/* HOA */}
                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classes.tabContent}>{'HOA'}</Typography>
                        {GetCurrencyString(propertyDetailsData.hoa, true)}
                    </div>

                    {/* R&M */}
                    <div className={classes.proformaSpacing}>
                        <Tooltip title={'Maintenance'}>
                            <Typography variant='body2' className={classes.tabContent}>{'R&M'}</Typography>
                        </Tooltip>
                        {GetCurrencyString(propertyDetailsData.maintenance, true)}
                    </div>

                    {/* Net Turnover */}
                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classes.tabContent}>{'Net Turnover'}</Typography>
                        {GetCurrencyString(propertyDetailsData.turnoverCost, true)}
                    </div>

                    {/* Leasing Fee */}
                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classes.tabContent}>{'Leasing Fee'}</Typography>
                        {GetCurrencyString(propertyDetailsData.leasingFee, true)}
                    </div>

                    {/* PM Fee */}
                    <div className={classes.proformaSpacing}>
                        <Tooltip title={'Management Fee'}>
                            <Typography variant='body2' className={classes.tabContent}>{'PM Fee'}</Typography>
                        </Tooltip>
                        {/* <Typography className={classes.tabSubContent} variant='body2'>
                            {propertyDetailsData.managementFee ? GetCurrencyString(propertyDetailsData.managementFee, true) : null}
                        </Typography> */}
                        {GetCurrencyString(propertyDetailsData.managementFee, true)}
                    </div>

                    <Divider variant='middle' />

                    {/* Total Expense */}
                    <div className={classNames(classes.proformaSpacing)}>
                        <Typography variant='body2' className={classNames(classes.fontBold, classes.tabContent)}>
                            {'Total Expense'}
                        </Typography>
                        {GetCurrencyString(propertyDetailsData.totalExpense, true, true)}
                    </div>
                </div>

                {/* NOI */}
                <div className={classes.proformaSpacing} style={{ 'marginTop': '5px' }}>
                    <Tooltip title={'Net Operating Income'}>
                        <Typography variant='body2' className={classNames(classes.fontBold, classes.tabContent)}>NOI</Typography>
                    </Tooltip>
                    {GetCurrencyString(propertyDetailsData.noi, false, true)}
                </div>

                <div className={classes.proformaSpacing}>
                    {/* Bid Price */}
                    <Tooltip title='Bid Price'>
                        <Typography variant='body2' className={classNames(classes.tabContent)}>Bid Price</Typography>
                    </Tooltip>
                    <Typography variant='body2' className={classNames(classes.valueSpacing, classes.tabContent)}>
                        {canDisplay(propertyDetailsData.price) ? ToCurrencyString(propertyDetailsData.price) : '-'}
                    </Typography>
                </div>

                <Typography variant='subtitle2' align='left'>{'COST BASIS'}</Typography>
                <div className={classes.groupContainer}>
                    {/* Cost Basis */}
                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classNames(classes.fontBold, classes.tabContent)}>
                            {'Cost Basis'}
                        </Typography>
                        {GetCurrencyString(propertyDetailsData.costBasis, false, true)}
                    </div>

                    {/* Carry Cost */}
                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classes.tabContent}>{'Carry Cost'}</Typography>
                        {GetCurrencyString(propertyDetailsData.carryCost, true)}
                    </div>

                    {/* Repairs */}
                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classes.tabContent}>{'Repairs'}</Typography>
                        {/* <Typography className={classes.tabSubContent} variant='body2'>
                            {propertyDetailsData.initialRepairs ? `${ToCurrencyStringWithDecimals(propertyDetailsData.initialRepairs)}` : null}
                        </Typography> */}
                        {GetCurrencyString(propertyDetailsData.initialRepairs, true)}
                    </div>

                    {/* Acquisition Cost */}
                    <div className={classes.proformaSpacing}>
                        <Typography variant='body2' className={classes.tabContent}>{'Acquisition Costs'}</Typography>
                        {GetCurrencyString(propertyDetailsData.acquisitionCosts, true)}
                    </div>

                    <Divider variant='middle' />

                    <div className={classes.proformaSpacing}>
                        <Tooltip title='Cap Rate'>
                            <Typography variant='body2' className={classNames(classes.fontBold, classes.tabContent)}>Cap Rate</Typography>
                        </Tooltip>
                        <Typography variant='body2' className={classNames(classes.fontBold, classes.valueSpacing, classes.tabContent)}>
                            {canDisplay(propertyDetailsData.capRate) ? ToPercentageString(propertyDetailsData.capRate) : '-'}
                        </Typography>
                    </div>
                </div>
            </Fragment>
        </div>
    )
};

const styles = theme => ({
    noContentPaper: {
        minHeight: '500px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    noMatchingErrorIcon: {
        fontSize: '2rem'
    },
    tabHeader: {
        fontSize: '14px',
    },
    tabContent: {
        fontSize: '12px',
    },
    tabSubContent: {
        flexGrow: '1',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingRight: '10px',
        fontSize: '0.6rem',
        color: 'gray',
    },
    proformaSpacing: {
        display: 'flex',
        width: '100%',
        padding: '0 10px',
    },
    fontBold: {
        fontWeight: 'bold',
    },
    fontRed: {
        color: theme.palette.red.main,
    },
    valueSpacing: {
        marginLeft: 'auto',
    },
    groupContainer: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white'
    },
})
export default withStyles(styles)(PropertyProforma)
